import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import UIButton from 'components/UIElements/UIButton';
import { previousModalPage } from 'actions/modalPage';
import CloseButton from 'components/CustomButtons/CloseButton';
import { useShortcut } from 'utils/hooks/keyboard/useShortcut';
import { getSerialNumberTitle } from 'reducers/configs/settings';

import CustomPromptsForm from './CustomPromptsForm';
import useCustomPromptsFormValidation from './useCustomPromptsFormValidation';

const SerialNumberPrompt = ({ resolve, reject, productName }) => {
  const { t } = useTranslation('customPrompts');

  const dispatch = useDispatch();

  const serialNumberTitle = useSelector(getSerialNumberTitle) as string;

  const {
    invalidPrompts,
    validate,
    getErrorText,
  } = useCustomPromptsFormValidation([serialNumberTitle]);

  const [data, setData] = useState(
    Object.fromEntries([[serialNumberTitle, '']]),
  );

  const confirm = () => {
    if (!invalidPrompts.length) {
      dispatch(previousModalPage());
      resolve(data[serialNumberTitle]);
    }
  };

  useShortcut('confirm', confirm, 30);

  const cancel = () => {
    dispatch(previousModalPage());
    reject(new Error(t('errors.serialNumber')));
  };

  return (
    <div data-testid="custom-prompt">
      <Modal.Header>
        <Modal.Title data-testid="title">{productName}</Modal.Title>
        <span style={{ flexGrow: 1 }} />
        <UIButton
          data-testid="save"
          variant="POS"
          text={t('buttons.confirm')}
          action={confirm}
          disabled={!!invalidPrompts.length}
        />

        <CloseButton data-testid="cancel" action={cancel} />
      </Modal.Header>
      <Modal.Body>
        <CustomPromptsForm
          prompts={[serialNumberTitle]}
          value={data}
          onChange={(sn, v) => setData({ [sn]: v })}
          validate={validate}
          getErrorText={getErrorText}
          autoFocus
        />
      </Modal.Body>
    </div>
  );
};

export default SerialNumberPrompt;
